<template>
  <div class="mr-3">
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize',
        apiBodyMeasures.length > 0 ? 'selected' : ''
      ]"
      @click="fieldData.showTargetGroupModal = true"
    >
      Målgrupp / Mått
    </button>
    <b-modal
      v-model="fieldData.showTargetGroupModal"
      dialog-class="targetgroupmodal"
      scrollable
      title="Välj målgrupper / mått"
      @hidden="cancelTargetGroups"
      @ok="saveTargetGroups"
      @show="showModal"
    >
      <b-form-row>
        <b-col sm="6">
          <label for="group-selection">Grupp</label>
          <b-form-select
            id="group-selection"
            v-model="form.group.selected"
            :options="form.group.options"
            size="sm"
          />
        </b-col>

        <b-col
          sm="6"
          class="mb-2"
        >
          <label for="measurements-selection">Mått</label>
          <b-form-select
            id="measurements-selection"
            v-model="fieldData.measurements.selected"
            :options="fieldData.measurements.options"
            size="sm"
          />
        </b-col>

        <b-col sm="4">
          <label for="age-from-selection">Ålder från</label>
          <b-form-select
            id="age-from-selection"
            v-model="form.age.from.selected"
            size="sm"
          >
            <option
              v-for="ageFrom in form.age.from.options"
              :key="ageFrom.value"
              :disabled="ageFrom.value < form.age.to.selected ? false : true"
              :value="ageFrom.value"
            >
              {{ ageFrom.text }}
            </option>
          </b-form-select>
        </b-col>

        <b-col sm="4">
          <label for="age-to-selection">Ålder till</label>
          <b-form-select
            id="age-to-selection"
            v-model="form.age.to.selected"
            size="sm"
          >
            <option
              v-for="ageTo in form.age.to.options"
              :key="ageTo.value"
              :disabled="ageTo.value > form.age.from.selected ? false : true"
              :value="ageTo.value"
            >
              {{ ageTo.text }}
            </option>
          </b-form-select>
        </b-col>
        <b-col sm="4">
          <label for="age-to-selection">Reachvillkor</label>
          <b-form-select
            id="reach-target-group"
            v-model="selectedReachCriteria"
            :disabled="isReachCriteriaDisabled"
            :options="reachCriteriaOptions"
            size="sm"
          />
        </b-col>
      </b-form-row>
      <b-form-row class="mt-3 mb-2">
        <b-col cols="12">
          <b-button
            class="mr-2"
            variant="success"
            size="sm"
            @click="add"
          >
            Lägg till
          </b-button>
          <b-button
            v-if="measures.length > 1"
            class="mr-2"
            variant="danger"
            size="sm"
            @click="deleteAllSelections"
          >
            Ta bort alla
          </b-button>
        </b-col>
      </b-form-row>
      <div class="pt-2">
        <small
          class="font-weight-bold"
        >Observera att för reach visas max upp till 28 dagar</small>
      </div>
      <b-list-group class="mt-3">
        <b-list-group-item
          v-for="(measure, index) in measures"
          :key="index"
        >
          <span>
            {{ measure.measure_name }}
          </span>
          <b-button
            class="mr-2 float-right"
            variant="danger"
            size="sm"
            @click="deleteSelection(index)"
          >
            Ta bort
          </b-button>
        </b-list-group-item>
      </b-list-group>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Avbryt
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Spara
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { fetchFormFieldData } from '../../../assets/js/api.js';
import globalConfig from "../../../mixins/globalConfig"

export default {
  name: 'TargetGroupCampaignModal',
  mixins: [globalConfig],
  props: {
    fieldData: Object,
    chosenPeriod: String,
  },
  data() {
    return {
     
      selectedReachCriteria: 5,
      reachCriteriaOptions: [
        { value: 1, text: '1 sek', selectedReachCriteriaText: '1 sek' },
        { value: 2, text: '2 sek', selectedReachCriteriaText: '2 sek' },
        { value: 5, text: '5 sek el 50% av längd', selectedReachCriteriaText: '5 sek/50%' },
        { value: 10, text: '10 sek', selectedReachCriteriaText: '10 sek' },
        { value: 15, text: '15 sek', selectedReachCriteriaText: '15 sek' },
        { value: 20, text: '20 sek', selectedReachCriteriaText: '20 sek' },
        { value: 30, text: '30 sek', selectedReachCriteriaText: '30 sek' },
        { value: 60, text: '60 sek', selectedReachCriteriaText: '60 sek' },
        { value: 120, text: '120 sek', selectedReachCriteriaText: '120 sek' },
        { value: 180, text: '180 sek', selectedReachCriteriaText: '180 sek' },
      ],
      measures: [],
      hasChange: false,
      form: {
        group: {
          selected: 'Alla',
          options: [
            { value: 'Alla', text: 'Alla' },
            { value: 'Kvinnor', text: 'Kvinnor' },
            { value: 'Män', text: 'Män' },
          ],
        },
        age: {
          from: {
            selected: 3,
            options: [],
          },
          to: {
            selected: 99,
            options: [],
          },
        },
      },
    };
  },
  computed: {
    isReachCriteriaDisabled() {
      let visibleReachSelectors = [
        ...this.fieldData.measurements.options.filter(measure => measure.showReachSelector),
      ].map(m => m.value);
      return !visibleReachSelectors.includes(this.fieldData.measurements.selected);
    },
    isReachSelected() {
      let isReachSelected = !this.isReachCriteriaDisabled;
      return isReachSelected;
    },
    apiBodyMeasures() {
      return this.$store.getters['campaignApiBody/getPayload'].measures;
    }
  },
  beforeDestroy() {
    // Clean up by removing the event listener when the component is destroyed
    document.removeEventListener("keyup", this.onKeyUp);
  },
  async created() {
    this.setupTargetGrups();
    if (localStorage.getItem('campaignMeasures'))
      this.measures = JSON.parse(localStorage.campaignMeasures);
    this.$store.commit('campaignApiBody/updateMeasures', this.measures);
  },
  methods: {
    onKeyUp(event) {
      if (event.key === "Enter" && this.fieldData.showTargetGroupModal) {
        this.fieldData.showTargetGroupModal = false;
        this.saveTargetGroups()      
      }
    },
    showModal() {
      document.addEventListener("keyup", this.onKeyUp);
      this.setTargetGroupsFromLocalStorage();
    },
    setTargetGroupsFromLocalStorage() {
      let storedTargets = localStorage.getItem('campaignMeasures')
        ? JSON.parse(localStorage.getItem('campaignMeasures'))
        : [];
      this.measures = storedTargets;
    },
    async setupTargetGrups() {
      let targetGroups = await fetchFormFieldData('TargetGroups');

      if (targetGroups.statusCode) {
        this.$bvToast.toast(targetGroups.errorMessage, {
          title: 'Varning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      }

      this.form.age.from.options = [];
      let uniqueTargetGoups = targetGroups.filter(function(obj) {
        return obj.gender === 'Man';
      });

      for (let index in uniqueTargetGoups) {
        this.form.age.from.options.push({
          value: uniqueTargetGoups[index].age_from,
          text: uniqueTargetGoups[index].age_from,
        });
        this.form.age.to.options.push({
          value: uniqueTargetGoups[index].age_to,
          text: uniqueTargetGoups[index].age_to,
        });
      }
    },
    add() {
      let maxTargetGroupCount;
      if (Number.isInteger(this.config_NumberOfTargetGroupsAd)) maxTargetGroupCount = this.config_NumberOfTargetGroupsAd
      else maxTargetGroupCount = 8
      if (this.measures.length >= maxTargetGroupCount) {
        this.$bvToast.toast('Max antal målgrupper är ' + maxTargetGroupCount, {
          title: 'Varning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      } else {
        this.addTargetGroup();
      }
    },
    addTargetGroup() {
      let min_viewing_time = 0;
      let gender = this.form.group.selected.charAt(0);
      let measurement = this.fieldData.measurements.selected;
      this.fieldData.measurements.options.forEach(element => {
        if (element.value == this.fieldData.measurements.selected) {
          measurement = element.text;
        }
      });
      let ageFrom = this.form.age.from.selected;
      let ageTo = this.form.age.to.selected;
      let targetGroupString = `${measurement} ${gender}${ageFrom}-${ageTo}`;
      if (this.isReachSelected) {
        min_viewing_time = this.selectedReachCriteria;
        let selectedReachCriteriaText = this.reachCriteriaOptions.filter(function(reachCriteria) {
          if (reachCriteria.value === this) return reachCriteria;
        }, this.selectedReachCriteria)[0].selectedReachCriteriaText;
        targetGroupString = `${targetGroupString}, ${selectedReachCriteriaText}`;
      }
      const targetGroupAlreadyExist = this.measures.some(
        tg => tg.measure_name === targetGroupString,
      );
      if (targetGroupAlreadyExist) {
        this.$bvToast.toast('Målgruppen finns redan', {
          title: 'Varning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      } else {
        this.updateMeasuresForSearch(targetGroupString, min_viewing_time);
      }
    },
    updateMeasuresForSearch(measureName, min_viewing_time) {
      let measure = {
        measure_type: this.fieldData.measurements.selected,
        consolidation_days: -1,
        target_group_keys: this.getTargetGroupKeys(),
        min_viewing_time,
        measure_name: measureName,
        ...this.isReachSelected && 
        {
          reachAbsHeader: this.fieldData.measurements.options.find(measure => measure.value === this.fieldData.measurements.selected).reachAbsHeader,
          reachRelHeader: this.fieldData.measurements.options.find(measure => measure.value === this.fieldData.measurements.selected).reachRelHeader,
          ageGroup: `${this.form.group.selected.charAt(0)}${this.form.age.from.selected}-${this.form.age.to.selected}`
        }
      };
      this.measures.push(measure);
    },
    getTargetGroupKeys() {
      let target_group_keys = [];
      this.form.age.to.options.forEach(age => {
        if (age.value <= this.form.age.to.selected && age.value > this.form.age.from.selected) {
          if (this.form.group.selected === 'Kvinnor' || this.form.group.selected === 'Alla') {
            target_group_keys.push('female_age' + age.value);
          }
          if (this.form.group.selected === 'Män' || this.form.group.selected === 'Alla') {
            target_group_keys.push('male_age' + age.value);
          }
        }
      });
      return target_group_keys;
    },
    deleteSelection(index) {
      this.measures.splice(index, 1);
    },
    deleteAllSelections() {
      this.measures = [];
    },
    cancelTargetGroups() {
      document.removeEventListener("keyup", this.onKeyUp);
      this.measures = [...this.$store.state.campaignApiBody.payload.measures];
    },
    saveTargetGroups() {
      //Add to vuex store
      this.$store.commit('campaignApiBody/updateMeasures', this.measures);
      this.$store.commit('campaignReachApiBody/updateMeasures', this.measures);
      //Add measures to local storage
      if (this.measures.length > 0) {
        localStorage.campaignMeasures = JSON.stringify(this.measures);
      } else {
        //Removes measures data from local storage if length is 0 and if the keys exist
        if (localStorage.getItem('campaignMeasures')) {
          localStorage.removeItem('campaignMeasures');
        }
      }
    },
  },
};
</script>
<style scoped>
.showline {
  text-decoration: line-through;
}
</style>